<script setup>
import { toRefs, defineProps, defineEmits, onMounted, ref, computed } from 'vue';
import Swal from "sweetalert2";
// import i18n from "@/i18n"
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    indicatorList: {
        type: Array,
        default: () => {
            return []
        }
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
    index_standard_calculation_mode_list: {
        type: Array,
        default: () => {
            return []
        }
    },
    category_name: {
        type: String,
        default: ''
    },
    currentTab: { //切换的语言
        type: Number,
        default: 1
    },
})

const emits = defineEmits(["update:indicatorList", "showInfo"])

const { indicatorList, index_standard_calculation_mode_list, currentTab
    //  category_name
} = toRefs(props)
const checkList = ref([
    {
        label: computed(() => currentTab.value == 1 ? getLangValueByKey('hscode.type.yes', 'ch', 2) : getLangValueByKey('hscode.type.yes', 'en', 2)),
        value: 1
    },
    {
        label: computed(() => currentTab.value == 1 ? getLangValueByKey('hscode.type.no', 'ch', 2) : getLangValueByKey('hscode.type.no', 'en', 2)),
        value: 0
    }
])
// console.log(getLangValueByKey('hscode.type.yes'));
const symbolsList = [
    { label: '≠', value: '≠' },
    { label: '>', value: '>' },
    { label: '<', value: '<' },
    { label: '≥', value: '≥' },
    { label: '≤', value: '≤' },
    { label: '=', value: '=' },
    { label: '∈', value: '[]' },
]

// const calculation_mode_list = [

// ]
const repeatList = ref([])
const repeatList_en = ref([])
const addGroupindicator = () => {
    //添加指标
    indicatorList.value.push({
        add: true,
        name: '',
        name_en: '',
        unit: '',
        unit_en: '',
        value: '',
        reference: '',
        reference_en: '',
        threshold: '',
        judgement_model: '',
        is_applicable: '0',
        is_specific: '0',
        calculation_mode: '', //计算方式
    });
    emits("update:indicatorList", [...indicatorList.value]);
}

const deleteGroupindicator = (i) => {
    //删除指标
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            indicatorList.value.splice(i, 1);
            emits("update:indicatorList", [...indicatorList.value]);
            changegroupindicatorName1()
            changegroupindicatorName1_en()
        }
    });

}


const changegroupindicatorName1 = () => {
    // 筛选数量大于1的内容
    let arr = indicatorList.value.map(item => item.name)
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        repeatList.value = [...duplicates]
        emits('showInfo', 3)
    } else {
        repeatList.value = []
    }
    // console.log(repeatList.value);
}
const changegroupindicatorName1_en = () => {
    // 筛选数量大于1的内容
    let arr = indicatorList.value.map(item => item.name_en)
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        repeatList_en.value = [...duplicates]
        emits('showInfo', 3)
    } else {
        repeatList_en.value = []
    }
    // console.log(repeatList.value);
}

// const setNum = (e) => {
//     //去掉某些符号
//     e.value = e.value.replace(/[^0-9.]/g, "");
// }

const restrictInput = (event, k) => {
    let value = indicatorList.value[k].threshold + '';
    // 获取按键的键值
    const key = event.key;

    // 允许的键：数字、删除键、小数点
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

    // 禁止输入 e, E, +, -
    if (['e', 'E', '+', '-'].includes(key)) {
        event.preventDefault(); // 阻止这些字符的输入
    }

    // 限制小数点只能输入一次
    if (key === '.' && value.includes('.')) {
        event.preventDefault(); // 如果已经有小数点，则阻止再次输入
    }

    // 如果按下的不是允许的键，则阻止输入
    if (!allowedKeys.includes(key)) {
        event.preventDefault();
    }
}

const validateInput = (k, type = 3) => {
    // 允许数字和一个小数点的输入
    let value
    if (type == 1) {
        value = indicatorList.value[k].threshold1;
    } else if (type == 2) {
        value = indicatorList.value[k].threshold2;
    } else {
        value = indicatorList.value[k].threshold;
    }

    // const validValue = `${indicatorList.value[k].threshold}`.match(/^\d*\.?\d*$/);
    // if (!validValue) {
    //     // 去除最后一个非法字符
    //     indicatorList.value[k].threshold = indicatorList.value[k].threshold.slice(0, -1);
    // }

    let cleanedInput = `${value}`.replace(/[^0-9.]/g, '');

    // 确保只允许输入一个小数点
    const decimalIndex = cleanedInput.indexOf('.');
    if (decimalIndex !== -1) {
        cleanedInput =
            cleanedInput.slice(0, decimalIndex + 1) +
            cleanedInput.slice(decimalIndex + 1).replace(/\./g, '');
    }
    value = cleanedInput
    // if(type ==1 || type ==2) {
    //     // 需要判断 threshold1 < threshold2
    //     if(indicatorList.value[k].threshold1!== '' && indicatorList.value[k].threshold2 !== ''  && indicatorList.value[k].threshold1 > indicatorList.value[k].threshold2) {
    //         // 提示
    //         threshold_range_error
    //     }
    // } 
}

/**
 * 增加排序
 */

const draggingIndex = ref(null); // 大类拖拽index
const onDragStart = (index) => {
    // 拖拽开始
    draggingIndex.value = index;
};

const onDragOver = (index,) => {
    // 拖拽结束
    if (draggingIndex.value !== index) {
        const draggedItem = indicatorList.value.splice(draggingIndex.value, 1)[0];
        indicatorList.value.splice(index, 0, draggedItem);
        draggingIndex.value = index;
    }
    // 移除所有dragging
    setTimeout(() => {
        document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
    }, 10000)
};

const onDrop = () => {
    // 离开
    draggingIndex.value = null;
};



onMounted(() => {
})
</script>
<template>
    <div class="group-index" v-if="indicatorList.length">
        <div class="group-index-title">
            <div><span style="color: red;">*</span>{{
                // getLangValue('hscode.indicatorName')
                currentTab == 1 ? getLangValueByKey('hscode.indicatorName') :
                    getLangValueByKey('hscode.indicatorName', 'en')
            }}</div>
            <div>{{
                // getLangValue('attribute.unit')
                currentTab == 1 ? getLangValueByKey('attribute.unit') : getLangValueByKey('attribute.unit', 'en')
            }}</div>
            <div>{{
                // getLangValue('attribute.reference')
                currentTab == 1 ? getLangValueByKey('attribute.reference') :
                    getLangValueByKey('attribute.reference', 'en') }}</div>
            <div>{{
                // getLangValue('hscode.standard_judgment_method')
                currentTab == 1 ? getLangValueByKey('hscode.standard_judgment_method') :
                    getLangValueByKey('hscode.standard_judgment_method', 'en') }}</div>
            <div>{{
                // getLangValue('hscode.threshold')
                currentTab == 1 ? getLangValueByKey('hscode.threshold') : getLangValueByKey('hscode.threshold', 'en') }}
            </div>

            <div style="flex:unset;width: 100px;">{{
                // getLangValue('hscode.is_it_applicable')
                currentTab == 1 ? getLangValueByKey('hscode.is_it_applicable') :
                    getLangValueByKey('hscode.is_it_applicable', 'en') }}</div>
            <div style="flex:unset;width: 100px;">{{
                // getLangValue('hscode.is_special_indicator')
                currentTab == 1 ? getLangValueByKey('hscode.is_special_indicator') :
                    getLangValueByKey('hscode.is_special_indicator', 'en') }}</div>
            <div style="flex:unset;width: 100px;">{{
                // getLangValue('hscode.calculation_mode')
                currentTab == 1 ? getLangValueByKey('hscode.calculation_mode') :
                    getLangValueByKey('hscode.calculation_mode', 'en') }}</div>
            <div style="flex:unset;width: 48px;"></div>
        </div>
        <div class="group-index-input list-group-item"
            v-for="(groupindicator, groupindicatorindicator_index) in indicatorList"
            :key="`groupindicator--${groupindicatorindicator_index}`" draggable="true"
            @dragstart="() => onDragStart(groupindicatorindicator_index)"
            @dragover.prevent="onDragOver(groupindicatorindicator_index)" @drop="onDrop()">
            <div>
                <!--  去掉所有disabled :disabled="!groupindicator.add && !groupindicator.canedit" -->
                <input v-model="groupindicator.name" type="text" class="form-control" :class="[
                    ((isCheckForm && !groupindicator.name) || (repeatList.includes(groupindicator.name) && (groupindicator.add || groupindicator.canedit))) && 'is-invalid',
                ]" required @change="changegroupindicatorName1(groupindicatorindicator_index)"
                    v-show="currentTab == 1" />
                <input v-model="groupindicator.name_en" type="text" class="form-control" :class="[
                    ((isCheckForm && !groupindicator.name_en) || (repeatList_en.includes(groupindicator.name_en) && (groupindicator.add || groupindicator.canedit))) && 'is-invalid',
                ]" required @change="changegroupindicatorName1_en(groupindicatorindicator_index)"
                    v-show="currentTab == 2" />
            </div>
            <div>
                <input v-model="groupindicator.unit" type="text" class="form-control" required
                    v-show="currentTab == 1" />
                <input v-model="groupindicator.unit_en" type="text" class="form-control" required
                    v-show="currentTab == 2" />
            </div>
            <div>
                <textarea style="height: 37.5px;" v-model="groupindicator.reference" class="form-control" required
                    v-show="currentTab == 1" />
                <textarea style="height: 37.5px;" v-model="groupindicator.reference_en" class="form-control" required
                    v-show="currentTab == 2" />
            </div>
            <!-- :disabled="!groupindicator.add && !groupindicator.canedit" -->
            <!-- :class="[
                        (isCheckForm && ((category_name== 3 && groupindicator.is_applicable) && groupindicator.threshold === '' || groupindicator.threshold == null)) && 'is-invalid',
                    ]" -->
            <div>
                <!-- :disabled="!groupindicator.add && !groupindicator.canedit" -->
                <!-- :class="[
                        (isCheckForm && ((category_name== 3 && groupindicator.is_applicable) && (groupindicator.judgement_model === '' || groupindicator.judgement_model == null))) && 'is-invalid',
                    ]" -->
                <Multiselect style="" id="garment" class="form-control" v-model="groupindicator.judgement_model"
                    label="label" value-prop="value" :close-on-select="true" :searchable="true" :create-option="false"
                    :options="symbolsList" />
            </div>
            <div>
                <template v-if="groupindicator.judgement_model == '[]'">
                    <input 
                    :title="currentTab == 1? getLangValueByKey('hscode.threshold_upper') : getLangValueByKey('hscode.threshold_upper', 'en')"
                    :class="[isCheckForm && ((typeof groupindicator.threshold1 == 'undefined' || groupindicator.threshold1==null  || groupindicator.threshold1==='')
                        || (!groupindicator.threshold1 !== '' && groupindicator.threshold2 !== '' &&
                            groupindicator.threshold1 >= groupindicator.threshold2)) && 'is-invalid',
                    ]" type="number" v-model="groupindicator.threshold1" class="form-control" required
                        style="width:45%; display:inline-block" @input="validateInput(groupindicatorindicator_index, 1)"
                        @keydown="(e) => restrictInput(e, groupindicatorindicator_index)" />-
                    <input
                   :title="currentTab == 1? getLangValueByKey('hscode.threshold_lower') : getLangValueByKey('hscode.threshold_lower', 'en')"
                    :class="[(isCheckForm && (typeof groupindicator.threshold2 == 'undefined' || groupindicator.threshold2==null  || groupindicator.threshold2==='')
                        || (groupindicator.threshold1 !== '' && groupindicator.threshold2 !== '' &&
                            groupindicator.threshold1 >= groupindicator.threshold2)) && 'is-invalid',
                    ]" type="number" v-model="groupindicator.threshold2" class="form-control" required
                        style="width:45%; display:inline-block" @input="validateInput(groupindicatorindicator_index, 2)"
                        @keydown="(e) => restrictInput(e, groupindicatorindicator_index)" />
                </template>
                <input v-else type="number" v-model="groupindicator.threshold" class="form-control" required
                    @input="validateInput(groupindicatorindicator_index)"
                    @keydown="(e) => restrictInput(e, groupindicatorindicator_index)" />
            </div>

            <!-- :disabled="!groupindicator.add && !groupindicator.canedit" -->
            <div style="flex:unset;width: 100px;">
                <Multiselect style="" id="is_applicable" class="form-control" v-model="groupindicator.is_applicable"
                    label="label" value-prop="value" :close-on-select="true" :searchable="true" :create-option="false"
                    :options="checkList" />
            </div>
            <!-- :disabled="!groupindicator.add && !groupindicator.canedit" -->
            <div style="flex:unset;width: 100px;">
                <Multiselect style="" id="is_specific" class="form-control" v-model="groupindicator.is_specific"
                    label="label" value-prop="value" :close-on-select="true" :searchable="true" :create-option="false"
                    :options="checkList" />
            </div>
            <div style="flex:unset;width: 100px;">
                <Multiselect style="" id="calculation_mode" class="form-control"
                    v-model="groupindicator.calculation_mode" label="name" value-prop="name" :close-on-select="true"
                    :searchable="true" :create-option="false" :options="index_standard_calculation_mode_list" />
            </div>
            <div style="height: 30px; flex: unset; display: inline;width: 48px;">
                <button v-if="groupindicator.add || groupindicator.canedit" type="button" class="btn"
                    style="background-color: #f06547;color: white; padding: 5px 10px; "
                    @click="deleteGroupindicator(groupindicatorindicator_index)">{{
                        // getLangValue("base.delete")
                        currentTab == 1 ? getLangValueByKey('base.delete') : getLangValueByKey('base.delete', 'en')
                    }}</button>
            </div>
        </div>
    </div>
    <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
        <button type="button" class="btn btn-primary me-3" style="background-color: #0AB39C;border: unset;"
            @click="addGroupindicator">{{
                // getLangValue("hscode.addIndicator")
                currentTab == 1 ? getLangValueByKey('hscode.addIndicator') : getLangValueByKey('hscode.addIndicator', 'en')
            }}</button>
    </div>
</template>
<style scoped lang="scss">
.group-content {
    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
        padding-right: 0 !important;
    }

    .list-group-item {
        padding: 5px 2px;
        border-left: unset;
        border-right: unset;
        transition: transform 0.2s, background-color 0.2s;
        cursor: grab;
    }


    .list-group-item.dragging {
        opacity: 0.5;
        background-color: #d1e7ff;
        transform: scale(1.05);
    }

    .group {
        margin: 10px 0;

        .multiselect {
            margin: unset !important;
        }

        .group-index {

            .group-index-title,
            .group-index-input {
                display: flex;
                align-items: center;

                div {
                    flex: 1;
                    margin: 10px;
                }
            }
        }
    }

}
</style>